import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Alert } from "antd";
import { CheckCircleFilled } from "@ant-design/icons";
import LoginWithOtp from "feature/authv2/components/LoginWithOtp";
import { tokenManager } from "services/client/token-manager";
import {
  SHOW_PORTAL_SELECTION_MODAL,
  userCanAccessDeskPortal,
} from "feature/authv2/portalDeskConfig";
import { useAgentAccountDetails } from "shared/hooks/common";

const LOGO_ICON = "/icons/carrum.svg";

export default function Login() {
  const [otpSuccessVisible, setOtpSuccessVisible] = useState(false);
  const { agentRole, allAgentDetails } = useAgentAccountDetails();
  const navigate = useNavigate();

  // If user already has a session, redirect to default page (no need to show login).
  useEffect(() => {
    if (tokenManager.getAccess() || tokenManager.getRefresh()) {
      const currentRoles = allAgentDetails?.role ?? agentRole;
      const path =
        SHOW_PORTAL_SELECTION_MODAL && userCanAccessDeskPortal(currentRoles) ? "/desk" : "/";
      navigate(path, { replace: true });
      return;
    }
  }, [agentRole, allAgentDetails, navigate]);

  const handleLoginSuccess = (accountDetails) => {
    if (SHOW_PORTAL_SELECTION_MODAL && userCanAccessDeskPortal(accountDetails?.role)) {
      navigate("/desk", { replace: true });
    } else {
      navigate("/", { replace: true });
    }
  };

  const handleOtpSent = () => setOtpSuccessVisible(true);

  useEffect(() => {
    if (!otpSuccessVisible) return;
    const t = setTimeout(() => setOtpSuccessVisible(false), 5000);
    return () => clearTimeout(t);
  }, [otpSuccessVisible]);

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        background: "#fff",
        padding: 24,
      }}
    >
      <div style={{ width: "100%", maxWidth: 400 }}>
        <div
          style={{
            background: "#fff",
            borderRadius: 16,
            padding: 32,
            marginBottom: 16,
            boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
          }}
        >
          <header style={{ textAlign: "center", marginBottom: 24 }}>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "left", gap: 8 }}>
              <img
                src={LOGO_ICON}
                alt=""
                style={{ width: 150, objectFit: "contain" }}
                aria-hidden
              />
            </div>
          </header>

          {/* {sessionExpired && (
            <Alert
              message="Session expired. Please log in again."
              type="warning"
              showIcon
              style={{ marginBottom: 16 }}
            />
          )} */}

          <h1
            style={{
              margin: "0 0 24px",
              fontSize: 24,
              fontWeight: 700,
              color: "#262626",
              textAlign: "left",
            }}
          >
            Login with us
          </h1>

          <LoginWithOtp onSuccess={handleLoginSuccess} onOtpSent={handleOtpSent} />
        </div>

        {otpSuccessVisible && (
          <Alert
            message="OTP sent successfully"
            type="success"
            showIcon
            icon={<CheckCircleFilled />}
            style={{ borderRadius: 24 }}
          />
        )}
      </div>
    </div>
  );
}
